import { Button as ButtonBase, ButtonProps } from '@mui/material'
import { styled } from '@mui/material/styles'

import { themeApp } from '../themes'

const Button = styled((props: ButtonProps) => <ButtonBase {...props} />)(({ theme }) => ({
  height: '50px',
  [theme.breakpoints.down('md')]: {
    fontSize: '12px',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '18px',
  },
  fontWeight: 'normal',
  color: theme.palette.secondary.dark,
  display: 'flex',
  alignItems: 'center',
  borderRadius: '5px',
  padding: '6px 40px',
  border: `1px solid ${theme.palette.secondary.dark}`,
  '&:hover': {
    backgroundColor: themeApp.hoverColor,
    color: '#FFFFFF',
    borderColor: theme.palette.primary.main,
  },
}))

export default Button
